<template>
  <div class="col-md-12 add-client-row row-height">
    <v-row class="">
      <v-col class="col-xl-1 col-lg-4 col-md-4" md="4" cols="12">
        <h3>
          <span class="font">Employers </span>
        </h3>
      </v-col>
      <v-col class="col-xl-2 col-lg-3 col-md-4 mb-10" md="4" cols="12">
        <v-text-field
          class="input-control"
          v-if="filteredArray.length > 0"
          @input="searchEmp"
          prepend-inner-icon="mdi-magnify"
          light
          dense
          outlined
          placeholder="Search Employers"
        >
        </v-text-field>
      </v-col>
      <v-col
        class="col-xl-9 col-lg-5 col-md-4 text-end"
        cols="12"
        v-if="$role != 'user'"
        align="end"
      >
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="my-1 blue-buttons">
              Add / Invite Employer
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <a
                class="a-tag underline-text"
                @click="
                  $router.push(
                    `/provider-advisor/providers/${routeParams}/employers/add-new`
                  )
                "
                >Add Employer</a
              >
            </v-list-item>
            <v-list-item>
              <a
                class="a-tag underline-text"
                @click="
                  $router.push(
                    `/provider-advisor/providers/${routeParams}/employers/invite-employer`
                  )
                "
                >Invite Employers</a
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <div class="col-md-12 text-center justify-center" v-if="readyToShow">
      <v-progress-circular
        indeterminate
        :size="100"
        color="primary"
        class="text-center"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-row class="col-md-12" v-if="allEmployers.length < 1 && !filterItems">
        <v-col md="12">
          You Have Not Yet Added any Employers to your Account -
          <a
            v-if="$role != 'user'"
            @click="
              $router.push(
                `/provider-advisor/providers/${routeParams}/employers/add-new`
              )
            "
            >Click Here to Add Employers.</a
          >
        </v-col>
      </v-row>
      <v-simple-table class="no-padding" v-else fixed-header height="630px">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Company Name</th>
              <th class="text-left"># of Employees</th>
              <th class="text-left"># of Members</th>
              <th class="text-left">Contract</th>
            </tr>
          </thead>
          <tbody v-if="allEmployers.length > 0">
            <tr
              v-for="(item, index) in allEmployers"
              :key="index"
              v-if="contractToView"
            >
              <td>
                <a @click="singleEmp(item)">{{ item.companyName }}</a>
              </td>
              <td>
                <span v-if="item.noEmployees">{{ item.noEmployees }}</span>
                <a v-else @click="showContract">Contract to View</a>
              </td>
              <td>
                <span v-if="item.noPlanMembers">{{ item.noPlanMembers }}</span>
                <a v-else @click="showContract">Contract to View</a>
              </td>
              <td>
                <a @click="showContract">Contract to View</a>
              </td>
            </tr>
            <tr v-else>
              <td>
                <a @click="singleEmp(item)">{{ item.companyName }}</a>
              </td>
              <td><a @click="showContract">Contract to View </a></td>
              <td><a @click="showContract">Contract to View </a></td>
              <td><a @click="showContract">Contract to View </a></td>
            </tr>
          </tbody>
          <div v-if="allEmployers.length < 1 && filterItems">
            <v-col md="12" cols="12">
              <v-alert
                border="bottom"
                colored-border
                type="warning"
                elevation="2"
                class="text-gray"
              >
                Sorry! No results found
              </v-alert>
            </v-col>
          </div>
        </template>
      </v-simple-table>
      <v-dialog v-model.trim="dialog" width="500">
        <v-card>
          <v-card-title class="text-h5"> PDF CONTRACT </v-card-title>
          <v-card-text>
            When user clicks “View Contract” on the Employer list from prior
            screen, then a PDF version of the contract is presented for the
            Provider user to view. This signature page of this PDF contract is
            populated with the Employer’s information (i.e. the Employer that
            they selected on the prior screen), and the compensation addendum is
            populated with the Provider’s contract rates. The user can view,
            print, and save this PDF.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue-buttons" text @click="dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from "../../../../../services/api";
export default {
  data() {
    return {
      items: [],
      allEmployers: [],
      response: [],
      dialog: false,
      contractToView: false,
      filterItems: false,
      readyToShow :false,
    };
  },
  created() {
    this.getAllEmployers();
    this.getAllContracts();
  },
  computed: {
    filteredArray() {
      return this.response;
    },
    routeParams() {
      return this.$route.params.name;
    },
  },
  methods: {
    showContract() {
      this.$router.push(
        `/provider-advisor/providers/${this.routeParams}/contracts`
      );
    },
    searchEmp(val) {
      this.allEmployers = this.filteredArray.filter((el) => {
        if (
          el.displayName &&
          el.displayName.toLowerCase().includes(val.toLowerCase())
        ) {
          return el.displayName.toLowerCase().includes(val.toLowerCase());
        } else if (
          el.companyName &&
          el.companyName.toLowerCase().includes(val.toLowerCase())
        ) {
          return el.companyName.toLowerCase().includes(val.toLowerCase());
        }
      });
      if (this.allEmployers.length < 1) {
        this.filterItems = true;
      }
    },
    singleEmp(item) {
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.providerAdvisor;
      let provider = JSON.parse(localStorage.getItem("provider"));
      api()
        .get(
          `/advisors/${advisorId}/providers/${provider._id}/employers/${item._id}`
        )
        .then((res) => {
          if (res) {
            this.$router.push(
              `/provider-advisor/providers/${this.routeParams}/employers/employer`
            );
            this.$store.commit("setSingleEmployer", res.data.employer);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllContracts() {
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.providerAdvisor;
      let provider = JSON.parse(localStorage.getItem("provider"));
      api()
        .get(`/advisors/${advisorId}/providers/${provider._id}/contract`)
        .catch((err) => {
          if (err) {
            this.contractToView = false;
            this.$store.commit("setEmpContractStatus", this.contractToView);
          }
        })
        .then((res) => {
          if (res) {
            this.contractToView = true;
            this.$store.commit("setEmpContractStatus", this.contractToView);
          }
        });
    },
    getAllEmployers() {
      this.readyToShow = true;
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.providerAdvisor;
      let provider = JSON.parse(localStorage.getItem("provider"));

      api()
        .get(`/advisors/${advisorId}/providers/${provider._id}/employers`)
        .then((res) => {
          this.allEmployers = res.data.employers;
          this.response = res.data.employers;
          this.readyToShow = false;
        })
        .catch((err) => {
          console.log(err.response);
          this.readyToShow = false;
        });
    },
  },
};
</script>
<style>
</style>